import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./Input.module.css";
import { Commet } from "react-loading-indicators";
import API from "../axios";

const Input = (props: any) => {
    // Input specification text
    const [specificationText, setSpecificationText] = useState("");

    // Expected results
    const [categories, setCategories] = useState<Array<object>>([]);

    // Loading status of each categories
    const [categoriesLoadingStatus, setCategoriesLoadingStatus] = useState<
        Array<any>
    >([]);

    // Result json from AI
    const [resultJson, setResultJson] = useState<any>({});

    const loadCategories = async function () {
        try {
            const result: any = await API.getExpectedResults();
            setCategories(result.data as Array<object>);

            // Move the categories to loading status
            let loadingStatus: Object[] = [];
            result.data.forEach((category: any) => {
                loadingStatus.push({
                    loading: true,
                    name: category.name,
                });
            });

            setCategoriesLoadingStatus(loadingStatus);
        } catch (error) {
            console.error("Failed to load categories:", error);
        }
    };

    /**
     * This function match each specification category with the AI result
     */
    const handleMatchSpecification = async function () {        
        props.setLoading(true);
        try {
            // Do the matching for all categories
            categories.forEach((category: any, index: number) => {
                API.matchSpecification(category.json, specificationText, index)
                    .then((result: string) => {
                        const parsed = JSON.parse(result);

                        // Filter to only subcategories defined in the expected template,
                        // preventing the AI from inventing subcategories (e.g. vehicle_information
                        // under 8_customization) that cause misplaced specs.
                        const templateKeys = category.json && typeof category.json === "object"
                            ? Object.keys(category.json)
                            : null;
                        const filtered = templateKeys
                            ? templateKeys.reduce<Record<string, any>>((acc, sub) => {
                                if (parsed[sub] !== undefined) acc[sub] = parsed[sub];
                                return acc;
                            }, {})
                            : parsed;

                        resultJson[category.key] = filtered;
                        setResultJson({ ...resultJson });

                        // Update loading status immutably
                        setCategoriesLoadingStatus((prev) =>
                            prev.map((s, i) => i === index ? { ...s, loading: false } : s)
                        );
                    })
                    .catch((error: any) => {
                        console.log(error.message);
                    });
            });
        } catch (error: any) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        loadCategories();
    }, []);

    /**
     * This watch all loading status and when it's all done
     * remove the loading modal
     */
    useEffect(() => {
        for (let i = 0; i < categoriesLoadingStatus.length; i++) {
            if (categoriesLoadingStatus[i].loading) {
                break;
            }

            if (
                !categoriesLoadingStatus[i].loading &&
                i == categoriesLoadingStatus.length - 1
            ) {
                setTimeout(() => {
                    props.setLoading(false);
                    for (let j = 0; j < categoriesLoadingStatus.length; j++) {
                        categoriesLoadingStatus[j].loading = true;
                    }
                }, 2000);
            }
        }
    }, [categoriesLoadingStatus]);

    useEffect(() => {
        if (!resultJson || Object.keys(resultJson).length === 0) return;
        props.handleUpdateResult(resultJson);
    }, [resultJson]);

    return (
        <>
            <Row>
                <Col className="text-center" cols="12">
                    <Row>
                        <Col cols="12" className="text-start">
                            {/* Input Field */}
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold mb-3">
                                        Input Raw Specification
                                    </Form.Label>
                                    <Form.Control
                                        className={styles.inputField}
                                        as="textarea"
                                        rows={10}
                                        placeholder="Copy and paste raw vehicle specificatioin here."
                                        value={specificationText}
                                        onChange={(e) =>
                                            setSpecificationText(e.target.value)
                                        }
                                    />
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                    <Row>
                        <Col cols="12" className="text-end">
                            {/* Submit button */}
                            <Button
                                onClick={handleMatchSpecification}
                                className="mx-2 bg-danger"
                            >
                                <i className="bi bi-trash mx-2"></i>
                                Clear Input
                            </Button>
                            {/* Submit button */}
                            <Button
                                onClick={handleMatchSpecification}
                                className="mx-2"
                            >
                                <i className="bi bi-cpu mx-2"></i>
                                Match Specification
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            {/* Loading dialog */}
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={props.loading}
            >
                <Modal.Body>
                    <Row>
                        <Col className="text-center" xs="12">
                            <p>Matching specification</p>
                            <Commet
                                size="small"
                                color={["#1D395E", "#F0A031", "#000"]}
                            />
                        </Col>
                        <ul className="list-group list-group-flush">
                            {categoriesLoadingStatus.map(
                                (status: any, index: number) => (
                                    <li
                                        className="list-group-item d-flex justify-content-between align-items-center"
                                        key={index}
                                    >
                                        {status.name}
                                        <span
                                            className={`badge ${
                                                status.loading
                                                    ? "bg-primary"
                                                    : "bg-success"
                                            } rounded-pill`}
                                        >
                                            {status.loading
                                                ? "Processing..."
                                                : "Done"}
                                        </span>
                                    </li>
                                )
                            )}
                        </ul>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Input;
